<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ modalTitle }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form
    [formGroup]="form"
    (ngSubmit)="saveChanges()"
  >
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <lib-deca-list-item
            [document]="document"
            [userCompanyId]="userCompanyId"
          ></lib-deca-list-item>
        </ion-col>
        <ion-col size="12">
          <ion-input
            type="datetime-local"
            formControlName="date"
            [label]="inputLabel"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            [errorText]="errorText"
          ></ion-input>
        </ion-col>
        <ion-col size="12">
          @if (isServiceStarted) {
            <lib-deca-edit-reason [form]="form.controls.changeReason"></lib-deca-edit-reason>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="saveChanges()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            Guardar cambios
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
